var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-alert',{staticClass:"loyalty_optin",attrs:{"title":"Bem-vindo ao programa de fidelidade Inspire 360, aqui suas compras acumulam pontos e seus pontos valem novos produtos!","type":"success"}},[_vm._v(" Confira no site "),_c('a',{attrs:{"href":"http://inspire360.com.br"}},[_vm._v("inspire360.com.br")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }